<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            Effectuer un <strong>paiement de masse </strong> / Information générale          </div>
         
          <b-row class="form-group">
            <b-col md="6">
              <label for="payeur">Payeur (*)</label>
              <b-form-input id="payeur" type="text" v-model="paiement.payeur" placeholder="Payeur"  @input="verif_info" class="form-control"></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="adresse">Adresse (*)</label>
              <b-form-input id="adresse" type="text" v-model="paiement.adresse" placeholder="Adresse Payeur"  @input="verif_info" class="form-control"></b-form-input>
            </b-col>  
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              <label for="code_paiement">Code paiement (*)</label>
              <b-form-input id="code_paiement" type="text" maxlength="8" v-model="paiement.code_paiement" placeholder="Code Paiement" size="8" length="8" @input="verif_info" class="form-control"></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="telephone">Téléphone (*)</label>
              <b-form-input id="telephone" type="text" v-model="paiement.telephone" placeholder="Téléphone Payeur" @input="verif_info" class="form-control"></b-form-input>
            </b-col>         
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              <label for="description">Motif (*)</label>
               <b-form-input id="description" type="text" v-model="paiement.motif" placeholder="Motif" @input="verif_info" class="form-control"></b-form-input>
            </b-col> 
            <b-col md="6">
              <label for="fileInput">Chargment du fichier (XLS, XLSX) (*)</label>
              <input type="file" id="fileInput" ref="myFiles"  @change="previewFiles" :plain="true" class="form-control"/>
            </b-col>  
          </b-row>
          <b-row class="form-group">
            <!--<b-col md="6">
              <label for="modelpaiement_id">Modèle du paiement du masse *</label>
                <el-select style="display:block;"
                  id="modelpaiement_id"
                  v-model="paiement.modelpaiement_id"
                  loading-text="Chargement en cours"
                  no-match-text="Modèle non trouvé"
                  no-data-text="Aucune données trouvées"
                  size="small"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Veuillez choisir le modèle du paiement de masse"
                  :remote-method="remoteModel"
                  :loading="loading">
                  <el-option
                    v-for="item in options4"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
              </b-col> -->
            <b-col md="6">
              <label for="modelpaiement_id">Modèle du paiement du masse *</label>
              <b-form-select id="modelpaiement_id" v-model="paiement.modelpaiement_id" :plain="true" :options="options_model">
              </b-form-select>
            </b-col>
          </b-row>
          <div slot="footer">
            <span v-if="verif"><b-button type="submit" size="sm" variant="primary" @click.prevent="confirm()"><i class="fa fa-dot-circle-o"></i> Valider</b-button></span>
            <b-button type="reset" @click="goBack" size="sm" variant="danger" v-if="!hidden_annuler"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
          <b-modal ref="myModalRef" hide-footer centered title="Confirmation du paiement de masse">
            <div class="d-block text-center">
              <p style>{{response.message}}</p>
              <h5>Voulez-vous continuer ?</h5>
            </div>
            <b-btn class="mt-3 col-lg-6" variant="outline-danger"  @click="cancel_Paiement" style="max-width: 100%;">Annuler</b-btn>
            <b-btn class="mt-3 col-lg-6" variant="outline-success"  @click="post" style="max-width: 100%;">Valider</b-btn>
          </b-modal>
        </b-card> 

        <b-card v-if="displayLine">
          <div slot="header">
            Liste des <strong>lignes</strong> érronées 
          </div>
          <vue-good-table styleClass="vgt-table condensed bordered striped" :columns="columns" :rows="ligne_paiement" :fixed-header="false" :pagination-options="pagination" :search-options="search">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'btn'" style="font-size: 0.875rem;">
                </span>
                <span v-else style="font-size: 0.875rem;">
                  {{props.formattedRow[props.column.field]}}
                </span>
              </template>
          </vue-good-table>
        </b-card>
    </b-col>
  </b-row>
</template>

<script>
var FormData = require('form-data');
var fs = require('fs');
import { VueGoodTable } from 'vue-good-table';
import api from '../../../api/'
export default {
  name: 'tables',
  data(){
    return {
      hidden_annuler:false,
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      displayLine :false,
      verif:false,
      model : [],
      options : [],
      options_model : [],
      options_typepiece : [],
      options_typeoperation : [],
      paiement:{
        code_paiement:'',
        payeur:'',
        adresse:'',
        telephone:'',
        paiement_file:File,
        motif:'',
        modelpaiement_id:''
      },
      atm:[],
      typepiece:[],
      typeoperation:[],
      files: [],
      ligne_paiement:[],
      columns: [],
      rows: [],
      options4: [],
      value9: [],
      list: [],
      loading: false,
      states: [],
      pagination:{
          enabled: true,
          mode: 'pages',
          perPage: 10,
          position: 'bottom',
          //perPageDropdown: [3,5, 10, 50,100],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'Suivant',
          prevLabel: 'Précédent',
          rowsPerPageLabel: 'Lignes par page',
          ofLabel: 'de',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
        },
        search:{
            enabled: true,
            trigger: 'keyup',
            placeholder: 'Rechercher dans la table',
        }
    }
  },
  methods:{
    get_all_linesError(){
        this.$store.dispatch('mandate/get_all_mandates').then(()=>{
          return this.rows =  store.getters['mandate/rows'];
        })
    },
     goBack() {
        this.$router.go(-1)
      },
    countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    verif_info(){
        if (this.paiement.payeur.length==0 || this.paiement.code_paiement.length==0 || this.paiement.telephone.length==0){
        this.verif = false
      }else{
        this.verif = true
      }
    },
    can(perm){
        return store.getters['auth/can'](perm)
    },
    previewFiles() {
      console.log(this.$refs)
      this.files = this.$refs.myFiles.files
      this.paiement_file = this.files[0]
      console.log('mes fichiers ',this.files[0])
    },
    async post(){
        let paiement_info = {
          id_paiement:this.response.data[0].id_paiement,
          code_paiement:this.response.data[0].code_paiement
          // adresse:this.response.data[0].adresse,
          // telephone:this.response.data[0].telephone
        }
        console.log("paiement info ",paiement_info)
        this.hideModal()
        this.hidden_annuler=true
        this.response = await this.$store.dispatch('mandate/post_paiement',paiement_info)
        this.showAlert()
        // if(this.response){
        //   this.hideModal() 
        // }
        this.reset()
        if(this.response.success == true){
          //let solde = await api.atm.get_auth_guichets(token)
          // let solde = await api.entity.get_balance_entites(token)
          // localStorage.setItem('solde', solde.data.data.solde)
          window.open(this.response.data.content, "_blank")
          setTimeout(function(){ location.reload(); }, 3000);
        }else{
          this.hidden_annuler=false
          location.reload()
        }
    },
    async cancel_Paiement(){
        let paiement_info = {
          id_paiement:this.response.data[0].id_paiement,
          code_paiement:this.response.data[0].code_paiement
        }
        this.response = await this.$store.dispatch('mandate/cancel_paiement',paiement_info)
        this.showAlert()
        if(this.response){
          this.hideModal() 
          location.reload()
        }
        //this.reset()

    },
    async confirm(){
        //this.response.success= true
        let fData = new FormData();
        fData.append('code_paiement', this.paiement.code_paiement);
        fData.append('payeur', this.paiement.payeur);
        fData.append('adresse', this.paiement.adresse);
        fData.append('telephone', this.paiement.telephone);
        fData.append('paiement_file', this.files[0]);
        fData.append('motif', this.paiement.motif);
        fData.append('modelpaiement_id', this.paiement.modelpaiement_id);
        this.response = await this.$store.dispatch('mandate/info_paiement',fData)
        //console.log("code paiement ",this.response.data[0].code_paiement)
        this.showAlert()
        if(this.response.success == true){
          this.displayLine = false
          this.$refs.myModalRef.show()
        }else{
          this.displayLine = true
          this.ligne_paiement =  store.getters['mandate/getLinesError'];
          console.log(this.ligne_paiement)
          this.ligne_paiement.forEach(element=>{

            for(var key in element){
                var found = this.columns.find(function(element1){
                  return element1.field===key
                });
                if(found == undefined){
                      this.columns.push({
                        label: key,
                        field: key,
                        filterable: true,
                        thClass: 'custom-th-class',
                        filterOptions: {
                          enabled: true, // enable filter for this column
                          placeholder: 'Filter This Thing', // placeholder for filter input
                          filterValue: '', // initial populated value for this filter
                          filterDropdownItems: [], // dropdown (with selected values) instead of text input
                          filterFn: this.columnFilterFn, //custom filter function that
                          trigger: 'keyup', //only trigger on enter not on keyup 
                        }
                    })
                }
            }

          })
          // this.columns.push({
          //   label: 'Erreur',
          //   field: 'error',
          //   filterable: true,
          //   filterOptions: {
          //     enabled: true, // enable filter for this column
          //     placeholder: 'Filter This Thing', // placeholder for filter input
          //     filterValue: '', // initial populated value for this filter
          //     filterDropdownItems: [], // dropdown (with selected values) instead of text input
          //     filterFn: this.columnFilterFn, //custom filter function that
          //     trigger: 'keyup', //only trigger on enter not on keyup 
          //   },
          // })
          return this.ligne_paiement
        }

    },
    hideModal () {
      this.$refs.myModalRef.hide()
    },
    
    async get_all_model(){
          // this.userConnected = await store.getters['auth/get_user']
          // let serverParams = {
          //     name:'',
          //     email:'',
          //     entite_nom:'',
          //     agence_nom:'',
          //     agence_ville:'',
          //     role_name:'',
          //     created_at:'',
          //     page:1,
          //     current_page: 1,
          //     nb_lines:10

          // }
          await this.$store.dispatch('mandate/get_all_model').then(()=>{
              return this.model = store.getters['mandate/rowsModels'];    
          })
          this.model.forEach((element)=>{
              this.options_model.push({
                value:element.id,
                text:element.model.toUpperCase()
              })
          }) 
           
    },
    remoteModel(query){
        if (query!=='') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options4 = this.options_model.filter(item => {
              return item.text.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
        } else {
          this.options4 = [];
        }
    },
    async postmontant(){
        let data = {
          montant_transfere:this.mandats.montant_transfere
        }
        this.response = await this.$store.dispatch('mandate/montantttc',data)
        this.mandats.montant_ttc = this.$store.getters['mandate/getMontant']
        this.showAlert()
        this.verif = false
        //console.log(this.$store.getters['mandate/getMontant'])
    },
    reset(){
        this.paiement.code_paiement= "",
        this.paiement.motif= "",
        this.paiement.payeur= "",
        this.paiement.adresse= "",
        this.paiement.telephone= "",
        this.paiement.paiement_file= ""
        this.paiement.modelpaiement_id= ""
    }
  },
  mounted(){
    this.get_all_model()
  }
}
</script>
